
/** -----------------------------------------------------------------------------------------------
 * WARNING! This script file is also used by the newer variant Contact Widget 2.0 !!!
 * --------------------------------------------------------------------------------------------- */

function ensureGoogleApi($) {
    if (typeof google === "undefined" || typeof google.maps === "undefined") {
        if (!document.mapsPromise) {
            if (document.googleApiKey) {
                document.mapsPromise =
                    $.getScript('https://maps.googleapis.com/maps/api/js?key=' + document.googleApiKey + '&callback=Function.prototype');
            } else {
                console.error('Required Google API key is missing');
            }
        }
        return document.mapsPromise;
    }
    return new $.Deferred().resolve(google.maps);
}

function initContactMap() {
    if (typeof google !== "undefined" && typeof google.maps !== "undefined") {
        loadMap(window.jQuery);
    } else {
        setTimeout(initContactMap, 100);
    }
}

function loadMap($) {
    var $containers = $('.contact-widget');
    $containers.each(function(index, container) {
        var $container = $(container);
        var $dataContainer =
            $container.find(
                '[data-share-latitude][data-share-longitude][data-share-company][data-share-street][data-share-zip-code][data-share-city][data-share-country][data-share-btn-text]');
        var latitude = $dataContainer.data('share-latitude');
        var longitude = $dataContainer.data('share-longitude');
        var company = $dataContainer.data('share-company');
        var street = $dataContainer.data('share-street');
        var zipCode = $dataContainer.data('share-zip-code');
        var city = $dataContainer.data('share-city');
        var country = $dataContainer.data('share-country');
        var btnText = $dataContainer.data('share-btn-text');
        var routeUrl = 'https://www.google.com/maps/search/?api=1&query=' + latitude + ',' + longitude;

        var markerPosition = { lat: latitude, lng: longitude };

        var mapElement = $container.find('.map');
        if (mapElement && mapElement.length) {
            mapElement = mapElement[0];
            var map = new google.maps.Map(mapElement,
                {
                    zoom: 15,
                    center: markerPosition
                });

            var btnId = 'btn-route-' + index;

            var contentString =
                '<div class="content">' +
                    '<h4>' +
                    company +
                    '</h4 >' +
                    '<div class="address">' +
                    '<p>' +
                    street +
                    '</p>' +
                    '<p>' +
                    zipCode +
                    ' ' +
                    city +
                    '</p>' +
                    '<p>' +
                    country +
                    '</p>' +
                    '</div>' +
                    '<a id="' +
                    btnId +
                    '" target="_blank" class="btn btn-primary btn-arrow">' +
                    btnText +
                    '</a>' +
                    '</div >';

            var infowindow = new google.maps.InfoWindow({
                content: contentString
            });

            var marker = new google.maps.Marker({
                position: markerPosition,
                map: map,
                icon: '/img/contact/contact_pointer.png'
            });
            marker.addListener('click',
                function() {
                    infowindow.open(map, marker);
                    setTimeout(function() {
                            $('#' + btnId).attr('href', routeUrl);
                        },
                        100);
                });
        }
    });
}

function initContact() {
    if (window.jQuery) {
        var widget = window.jQuery('.contact-widget');
        if (widget && widget.length > 0) {
            var apiPromise = ensureGoogleApi(window.jQuery);
            if (apiPromise) {
                apiPromise.then(initContactMap());
            }
        }
    } else {
        setTimeout(initContact, 100);
    }
}

document.addEventListener("DOMContentLoaded",
    function () {
            initContact();
    });